// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__jqZtp","signatureButtonsRight":"ModalSign_signatureButtonsRight__2ePh1"};